module.exports = __webpack_public_path__ + "img/source2.278941c2.png";